var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "text-center"
  }, [_c('v-dialog', {
    attrs: {
      "persistent": "",
      "width": "1200"
    },
    model: {
      value: _vm.localVisible,
      callback: function ($$v) {
        _vm.localVisible = $$v;
      },
      expression: "localVisible"
    }
  }, [_c('v-card', {
    staticClass: "not-margin pt-0 pr-0 pl-0"
  }, [_c('v-toolbar', {
    attrs: {
      "dark": "",
      "color": "primary"
    }
  }, [_c('div', {
    staticClass: "text-center"
  }, [_c('v-icon', [_vm._v(" " + _vm._s(_vm.isView ? 'mdi-eye-outline' : 'mdi-pencil'))]), _vm._v(" " + _vm._s(_vm.edit ? _vm.isView ? "Visualizar" : "Editar" : "Cadastrar") + " Solicitação de Formação ")], 1)]), _c('v-tabs', {
    staticClass: "tabs",
    attrs: {
      "fixed-tabs": "",
      "background-color": "transparent"
    },
    model: {
      value: _vm.tab,
      callback: function ($$v) {
        _vm.tab = $$v;
      },
      expression: "tab"
    }
  }, [_c('v-tab', {
    class: _vm.disabledClass,
    on: {
      "click": function ($event) {
        return _vm.setTab(0);
      }
    }
  }, [_vm._v("Plano de Trabalho")]), _c('v-tab', {
    class: _vm.disabledClass,
    on: {
      "click": function ($event) {
        return _vm.setTab(1);
      }
    }
  }, [_vm._v("Programação")]), _c('v-tab', {
    class: _vm.disabledClass,
    on: {
      "click": function ($event) {
        return _vm.setTab(2);
      }
    }
  }, [_vm._v("Orçamento")])], 1), _c('v-tabs-items', {
    model: {
      value: _vm.tab,
      callback: function ($$v) {
        _vm.tab = $$v;
      },
      expression: "tab"
    }
  }, [_c('v-tab-item', [_vm.tab === 0 ? _c('v-form', {
    ref: "formPlanoTrabalho"
  }, [_c('AbaPlanoTrabalho', {
    ref: "abaPlanoTrabalhoFrom",
    attrs: {
      "content": _vm.content.abaPlanoTrabalho
    },
    on: {
      "onClose": _vm.onClose,
      "onSave": _vm.onSave,
      "changeTab": _vm.changeTab
    }
  })], 1) : _vm._e()], 1), _c('v-tab-item', [_vm.tab === 1 ? _c('v-form', {
    ref: "formAbaProgramacao"
  }, [_c('AbaProgramacao', {
    ref: "abaProgramacaoFrom",
    attrs: {
      "content": _vm.content.abaProgramacao
    },
    on: {
      "onClose": _vm.onClose,
      "onSave": _vm.onSave,
      "changeTab": _vm.changeTab
    }
  })], 1) : _vm._e()], 1), _c('v-tab-item', [_vm.tab === 2 ? _c('v-form', {
    ref: "formAbaOrcamento"
  }, [_c('AbaOrcamento', {
    ref: "abaOrcamentoFrom",
    attrs: {
      "content": _vm.content.abaOrcamento
    },
    on: {
      "onClose": _vm.onClose,
      "changeTab": _vm.changeTab
    }
  })], 1) : _vm._e()], 1)], 1)], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }